import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import { dataHooks } from './TrendIndicator.constants';

export interface TrendIndicatorUniDriver extends BaseUniDriver {
  hasTrendIndicatorIcon(): Promise<boolean>;
  isTrendIndicatorIconUp(): Promise<boolean>;
  isTrendIndicatorIconDown(): Promise<boolean>;
  getTrendValue(): Promise<number>;
  getFormattedTrendValue(): Promise<string>;
}

export const trendIndicatorDriverFactory = (
  base: UniDriver,
): TrendIndicatorUniDriver => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Returns true if trend icon exist
     */
    hasTrendIndicatorIcon: () =>
      findByHook(base, dataHooks.trendIndicatorIcon).exists(),

    /**
     * Returns true if trend icon is sort up
     */
    isTrendIndicatorIconUp: () =>
      findByHook(base, dataHooks.trendIndicatorUp).exists(),

    /**
     * Returns true if trend icon is sort down
     */
    isTrendIndicatorIconDown: () =>
      findByHook(base, dataHooks.trendIndicatorDown).exists(),

    /**
     * Gets trend value
     */
    getTrendValue: async () => {
      const text = await findByHook(base, dataHooks.trendIndicatorValue).text();

      return Number(text.replace('%', ''));
    },

    /**
     * Gets formatted trend value
     */
    getFormattedTrendValue: async () => {
      const text = await findByHook(base, dataHooks.trendIndicatorValue).text();

      return text;
    },
  };
};
